export const getUrlObject = (urlString: string) => {
  const url = new URL(urlString);
  return url;
};
